module.exports = __webpack_public_path__ + "static/media/iconsBrands.2a31e0df.svg";